import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'

/**
 * @function getPictureLayerNumber 获取导出图片包的指标和点位层级
 * @param {String} type 类型 points 点位 standards 指标
 * @return {Number} id 下载任务 id
 */
const getPictureLayerNumber = (type) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/download/picture/getLayerNumber?forArea=${
        type === 'points'
      }`
    )
    .then(checkResponse)
}

/**
 * @function createTaskPicture 创建图片包下载任务
 * @param {String} query query为使用 qs 格式化过的参数 {folderOrder: 文件夹顺序, watermark: 是否带水印, areaLayer: 点位层级, standardLayer: 指标层级, caseSearch: 案件列表查询条件}
 */
const createTaskPicture = (query) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/download/picture/form?${query}`)
    .then(checkResponse)
}

export {
  getPictureLayerNumber,
  createTaskPicture,
}
